import { AccommodationDashboardPage } from '@components/dashboard/accommodation/AccommodationDashboardPage';
import { OtaPayoutsPage } from '@components/dashboard/accommodation/OtaPayoutsPage';
import { AccommodationPaymentsPage } from '@components/dashboard/accommodation/bookings/AccommodationPaymentsPage';
import { BookingDetailPage } from '@components/dashboard/accommodation/bookings/BookingDetailPage';
import { BookingsIndexPage } from '@components/dashboard/accommodation/bookings/BookingsIndexPage';
import { NewBookingPage } from '@components/dashboard/accommodation/bookings/NewBookingPage';
import { OverstaysPage } from '@components/dashboard/accommodation/bookings/OverstaysPage';
import { AccommodationGuestsPage } from '@components/dashboard/accommodation/guests/AccommodationGuestsPage';
import { AccommodationReportsLayout } from '@components/dashboard/accommodation/reports/AccommodationReportsLayout';
import { BookingSourceReportPage } from '@components/dashboard/accommodation/reports/BookingSourceReportPage';
import { NightAuditReportPage } from '@components/dashboard/accommodation/reports/NightAuditReportPage';
import { OccupancyReportPage } from '@components/dashboard/accommodation/reports/OccupancyReportPage';
import { RevParReportPage } from '@components/dashboard/accommodation/reports/RevParReportPage';
import { RevenueReportPage } from '@components/dashboard/accommodation/reports/RevenueReportPage';
import { RoomRevenueReportPage } from '@components/dashboard/accommodation/reports/RoomRevenueReportPage';
import { AccommodationReviewsPage } from '@components/dashboard/accommodation/reviews/AccommodationReviewsPage';
import { RoomsPage } from '@components/dashboard/accommodation/rooms/RoomsPage';
import { PropertiesPage } from '@components/dashboard/accommodation/settings/PropertiesPage';
import { PropertySettingsPage } from '@components/dashboard/accommodation/settings/PropertySettingsPage';
import { RatePlansPage } from '@components/dashboard/accommodation/settings/RatePlansPage';
import { AccessControlCode } from '@shared/constants';
import { Navigate, Route } from 'react-router-dom';
import { AccommodationPage } from '../pages/AccommodationPage';
import { AccessControlledDashboardPage } from './featureRouteHelpers';

export const createAccommodationRoutes = () => (
  <Route path="/accommodation" element={<AccommodationPage />}>
    <Route index element={<Navigate to="/accommodation/dashboard" replace />} />
    <Route path="dashboard" element={<AccommodationDashboardPage />} />
    <Route path="bookings" element={<BookingsIndexPage />} />
    <Route path="bookings/new" element={<NewBookingPage />} />
    <Route path="bookings/:bookingId" element={<BookingDetailPage />} />
    <Route path="overstays" element={<OverstaysPage />} />
    <Route path="rooms" element={<RoomsPage />} />
    <Route
      path="guests"
      element={
        <AccessControlledDashboardPage
          control={AccessControlCode.ACCOMMODATION_GUESTS_VIEW}
          title="Guests access restricted"
          description="Your account does not have permission to view accommodation guests."
        >
          <AccommodationGuestsPage />
        </AccessControlledDashboardPage>
      }
    />
    <Route path="reports" element={<AccommodationReportsLayout />}>
      <Route
        index
        element={<Navigate to="/accommodation/reports/revenue" replace />}
      />
      <Route
        path="revenue"
        element={
          <AccessControlledDashboardPage
            control={AccessControlCode.ACCOMMODATION_REPORTS_REVENUE}
            title="Revenue report access restricted"
            description="Your account does not have permission to view the revenue report."
          >
            <RevenueReportPage />
          </AccessControlledDashboardPage>
        }
      />
      <Route
        path="occupancy"
        element={
          <AccessControlledDashboardPage
            control={AccessControlCode.ACCOMMODATION_REPORTS_OCCUPANCY}
            title="Occupancy report access restricted"
            description="Your account does not have permission to view the occupancy report."
          >
            <OccupancyReportPage />
          </AccessControlledDashboardPage>
        }
      />
      <Route
        path="booking-source"
        element={
          <AccessControlledDashboardPage
            control={AccessControlCode.ACCOMMODATION_REPORTS_BOOKING_SOURCE}
            title="Booking source report access restricted"
            description="Your account does not have permission to view the booking source report."
          >
            <BookingSourceReportPage />
          </AccessControlledDashboardPage>
        }
      />
      <Route
        path="night-audit"
        element={
          <AccessControlledDashboardPage
            control={AccessControlCode.ACCOMMODATION_REPORTS_NIGHT_AUDIT}
            title="Night audit access restricted"
            description="Your account does not have permission to view the night audit report."
          >
            <NightAuditReportPage />
          </AccessControlledDashboardPage>
        }
      />
      <Route
        path="room-revenue"
        element={
          <AccessControlledDashboardPage
            control={AccessControlCode.ACCOMMODATION_REPORTS_ROOM_REVENUE}
            title="Room revenue report access restricted"
            description="Your account does not have permission to view the room revenue report."
          >
            <RoomRevenueReportPage />
          </AccessControlledDashboardPage>
        }
      />
      <Route
        path="revpar"
        element={
          <AccessControlledDashboardPage
            control={AccessControlCode.ACCOMMODATION_REPORTS_REVPAR}
            title="RevPAR report access restricted"
            description="Your account does not have permission to view the RevPAR report."
          >
            <RevParReportPage />
          </AccessControlledDashboardPage>
        }
      />
    </Route>
    <Route
      path="reviews"
      element={
        <AccessControlledDashboardPage
          control={AccessControlCode.ACCOMMODATION_REVIEWS_VIEW}
          title="Reviews access restricted"
          description="Your account does not have permission to view accommodation guest reviews."
        >
          <AccommodationReviewsPage />
        </AccessControlledDashboardPage>
      }
    />
    <Route
      path="payments"
      element={
        <AccessControlledDashboardPage
          control={AccessControlCode.ACCOMMODATION_PAGE_ACCESS}
          title="Payments access restricted"
          description="Your account does not have permission to view accommodation payments."
        >
          <AccommodationPaymentsPage />
        </AccessControlledDashboardPage>
      }
    />
    <Route
      path="ota-payouts"
      element={
        <AccessControlledDashboardPage
          control={AccessControlCode.ACCOMMODATION_PAGE_ACCESS}
          title="OTA payouts access restricted"
          description="Your account does not have permission to view OTA payouts."
        >
          <OtaPayoutsPage />
        </AccessControlledDashboardPage>
      }
    />
    <Route path="settings" element={<PropertySettingsPage />} />
    <Route path="settings/properties" element={<PropertiesPage />} />
    <Route path="settings/rate-plans" element={<RatePlansPage />} />
  </Route>
);
